import React from 'react';

import ForecastQueryRenderer from '../../../../../../../ForecastQueryRenderer';
import {hasTopDownProgramBudgetFeature} from '../../../../../util/ProgramFinancialLogic';
import TimeRegistrationModal, {
	TimeRegistrationModalBaseProps,
	TimeRegistrationModalQuery,
} from '../modal-content/TimeRegistrationModal';
import {TimeRegistrationEntityId} from '../types/TimeRegistrationEntityId';
import {toBackendEntityId} from '../util/TimeRegistrationModalUtil';

import type {TimeRegistrationModal_viewer} from '../modal-content/__generated__/TimeRegistrationModal_viewer.graphql';
import type {RelayRefetchProps} from '../../../../../../../relay-helpers/TSRelayConverter';
import {TimeRegistrationInitialState} from '../types/TimeRegistrationInitialState';

interface TimeRegistrationModalQueryWrapperProps extends TimeRegistrationModalBaseProps {
	personId: string | null;
	entityId: TimeRegistrationEntityId | null;
	projectId: string | undefined;
	showCloseButton?: boolean;
	initialState?: TimeRegistrationInitialState;
}

function TimeRegistrationModalQueryWrapper({
	personId,
	entityId,
	projectId,
	...modalProps
}: TimeRegistrationModalQueryWrapperProps): JSX.Element {
	const entityVariables = entityId ? toBackendEntityId(entityId, projectId) : {};
	const hasTopDownProgramBudgetFeatureFlag = hasTopDownProgramBudgetFeature();
	return (
		<ForecastQueryRenderer
			key="query-render-bulk-task-update-standalone"
			query={TimeRegistrationModalQuery}
			modal={true}
			showLoader={false}
			variables={{
				personId,
				fetchProgramInfo: hasTopDownProgramBudgetFeatureFlag,
				...entityVariables,
			}}
			render={(relayProps: RelayRefetchProps<TimeRegistrationModal_viewer>) => {
				return <TimeRegistrationModal {...relayProps} {...modalProps} selectedPersonId={personId} />;
			}}
		/>
	);
}

export default TimeRegistrationModalQueryWrapper;
